export enum LoanType {
    CONVENTIONAL = 'CONVENTIONAL',
    FHA = 'FHA',
    VA = 'VA'
}

export const loanTypeDisplay = {
    [LoanType.CONVENTIONAL]: 'Conventional',
    [LoanType.FHA]: 'FHA',
    [LoanType.VA]: 'VA'
};
